import featuredimg1 from '../../assets/Images/property/featuredimg1.webp'
import featuredimg3 from '../../assets/Images/property/featuredimg3.jpg'
import featuredimg2 from '../../assets/Images/property/featuredimg2.jpg'
import sale4 from '../../assets/Images/property/sale4.png'
import sale5 from '../../assets/Images/property/sale5.png'
import sale6 from '../../assets/Images/property/sale6.png'
import sale7 from '../../assets/Images/property/sale7.png'
import sale8 from '../../assets/Images/property/sale8.png'
import sale9 from '../../assets/Images/property/sale9.png'

export const sale = [
    {
        image:featuredimg1,
        price:"4,250",
        title:"Semi detached house",
        address:"Southfield Road, Oxford OX4",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:featuredimg3,
        price:"654,250",
        title:"semi detached house",
        address:"Southfield Road, Oxford OX4",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:featuredimg2,
        price:"926,250",
        title:"Bunglow",
        address:"Leeds city center",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale4,
        price:"106,250",
        title:"Bunglow",
        address:"Derby side country ",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"4",
        bath:"4",
        furniture:"un-furnished",
    },
    {
        image:sale5,
        price:"904,250",
        title:"semi detached house",
        address:"Southfield Road, Oxford OX4",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale6,
        price:"336,250",
        title:"penthouse",
        address:"Menchester city",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"1",
        bath:"1",
        furniture:"semi-furnished",
    },
    {
        image:sale7,
        price:"107,250",
        title:"Bunglow",
        address:"Leeds city center",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"4",
        bath:"4",
        furniture:"semi-furnished",
    },
    {
        image:sale8,
        price:"829,250",
        title:"penthouse ",
        address:"Menchester city",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"1",
        bath:"2",
        furniture:"un-furnished",
    },
    {
        image:sale9,
        price:"100,250",
        title:"Semi detached house",
        address:"Southfield Road, Oxford OX4",
        para:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis amet consectetur adipisicing elit. molestiae qui hic quis illo.",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
   
   
   
   
   

]